import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: `button-new`,
  template: `
    <button class="btn btn-success d-print-none {{btnClass}}" [type]="type" [disabled]="disabled" aria-label="New" (click)="onClick()"
            ngbTooltip="New">
      <i class="fa fa-plus" aria-hidden="true"></i> {{ label }}
    </button>
  `
})
export class NewbuttonComponent {
  @Output() btnClick = new EventEmitter();
  @Input() disabled = false;
  @Input() type = 'button';
  @Input() btnClass = '';
  @Input() label = '';

  onClick(): void {
    this.btnClick.emit();
  }
}
